export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/bg.lyaml"));
at({ "bg": { "public": { "sampleString": "\u041E\u0431\u0438\u043A\u043D\u043E\u0432\u0435\u043D \u043D\u0438\u0437" } } });
};